export default __webpack_public_path__ + "static/6-003e3894ecf8808bf350dec0467adcce.jpg";